<script setup>
import { Icon, Button } from '@components'

const emit = defineEmits(['click'])

const props = defineProps({
    text: {
        type: String,
        default: 'Next'
    }
})
</script>

<template>
    <Button size="xl" type="primary" radius="square" classButton="w-full justify-between" @click="emit('click')">
        <div class="w-[95%]">{{ props.text }}</div>
        <template #after>
            <Icon name="arrowNarrowRight" size="20px"></Icon>
        </template>
    </Button>
</template>

<style>

</style>